import { ButtonConfig } from '@ardoq/view-settings';
import { GhostButton } from '@ardoq/button';
import { Icon, IconSize } from '@ardoq/icons';
import { SettingsBarPopover } from './SettingsBarPopover';

export const Button = ({
  label,
  iconName,
  onClick,
  isDisabled = false,
  isActive,
  id,
  popoverText,
}: ButtonConfig) => {
  return (
    <SettingsBarPopover popoverText={popoverText}>
      <GhostButton
        data-click-id={id}
        onClick={isDisabled ? undefined : onClick}
        data-tooltip-text={popoverText ? undefined : label}
        aria-label={label}
        isActive={
          isActive &&
          !isDisabled /* active disabled state is possible, but we are not using it. */
        }
        isDisabled={isDisabled}
      >
        <Icon iconName={iconName} iconSize={IconSize.MEDIUM} />
      </GhostButton>
    </SettingsBarPopover>
  );
};
